import './KlarnaPaymentView.scss'

import { Text } from '@tallink/components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as KlarnaLogo } from '../../../../icons/logo_klarna.svg'

export default function KlarnaPaymentView() {
  const { t } = useTranslation()
  return (
    <Text className="klarna-payment-view">
      <section className="klarna-policy">
        <p className="klarna-text">{t('payment.klarna.options.title')}</p>
        <div className="klarna-policy-in">
          <ul className="klarna-list" dangerouslySetInnerHTML={{ __html: t('payment.klarna.options.list') }} />
          <div className="klarna-logo">
            <KlarnaLogo preserveAspectRatio="xMidYMid meet" />
          </div>
        </div>
      </section>
      <section className="klarna-policy" dangerouslySetInnerHTML={{ __html: t('payment.klarna.policy') }} />
    </Text>
  )
}
